import React from "react";
import { Routes, Route } from "react-router-dom";
import { MenuArea } from "core/constants";
import { useUpdateMenu } from "core/hooks";
import ActivityLogging from "../self-service/users/activity-logging/index";
import Users from "self-service/users/management/users";

const UsersLayout = () => {
    console.log("render");

    useUpdateMenu(MenuArea.manage);

    return (
        <Routes>
            <Route path="*" element={<Users />} />
            <Route path="/logging" element={<ActivityLogging />} />
        </Routes>
    );
}

export default UsersLayout;
